import NavigationMenu from "./NavigationMenu";
import JitsiMeeting from "./JitsiMeeting";
import UserCard from "./UserCard";
import Carousel from "./Carousel";
import AppBar from "./AppBar";
import AddScreenshotDialog from "./AddScreenshotDialog";
import PhoneInput from "./PhoneInput";
import LeadPartyListTable from "./LeadPartyListTable";
import OngoingProcessListTable from "./OngoingProcessListTable";
import AllOngoingProcessListTable from "./AllOngoingProcessListTable";
import AssignmentListTable from "./AssignmentListTable";
import ChooseProcessDialog from "./ChooseProcessDialog";
import JoiningVideoCallDialog from "./JoiningVideoCallDialog";
import SimpleWarningDialog from "./SimpleWarningDialog";
import AssignToInitiatorDialog from "./AssignToInitiatorDialog";
import AssignProcessDialog from "./AssignProcessDialog";
import AddNoteDialog from "./AddNoteDialog";
import DropAssigneeDialog from "./DropAssigneeDialog";
import TabHolder from "./TabHolder";
import CheckList from "./CheckList";
import BasicList from "./BasicList";

const Components = {
  UserCard,
  Carousel,
  AddScreenshotDialog,
  TabHolder,
  CheckList,
  BasicList
};

const LayoutComponents = {
  AppBar,
  NavigationMenu
};

const JitsiComponents = {
  JitsiMeeting
};

const AuthAndVideoCallComponents = {
  UserCard,
  OngoingProcessListTable,
  JoiningVideoCallDialog,
  SimpleWarningDialog,
  AddNoteDialog,
  DropAssigneeDialog
};

const AllAuthAndVideoCallComponents = {
  UserCard,
  AllOngoingProcessListTable,
  JoiningVideoCallDialog,
  SimpleWarningDialog,
  AddNoteDialog,
  DropAssigneeDialog
};

const AuthAndVideoCallApproveComponents = {
  UserCard,
  AssignmentListTable,
  SimpleWarningDialog,
  AssignToInitiatorDialog,
  AssignProcessDialog,
  AddNoteDialog
};

const LeadPartyListComponents = {
  UserCard,
  LeadPartyListTable,
  ChooseProcessDialog,
  SimpleWarningDialog,
  AddNoteDialog
};

const CreateNewIdentityComponents = {
  SimpleWarningDialog,
  PhoneInput
};

export { JitsiComponents };
export { LayoutComponents };
export { AuthAndVideoCallComponents };
export { AllAuthAndVideoCallComponents };
export { AuthAndVideoCallApproveComponents };
export { LeadPartyListComponents };
export { CreateNewIdentityComponents };
export default Components;



// WEBPACK FOOTER //
// ./src/components/index.js